import React from 'react';
import { Hash, User, Users } from 'lucide-react';
import { Card, Field, FieldGrid } from './Card';
import Toggle from './Toggle';

/**
 * Group Assignment. Group and Staff come from the Group Organizer (`groupAssignment` on
 * `bookingcamperdetail`: { number, name, staff } or null), shown as saved there, so a participant
 * cancelled after the groups were saved still shows their group. Code is the booking's own
 * `campers.groupCode`, unrelated to the organizer.
 *
 * "Approved" (client request) lets a director count the readiness group check as done without an
 * assignment. It only overrides readiness; the fields still show the real data. Shown when the
 * program uses groups (`groupsSaved`; otherwise the check isn't scored at all) and the participant
 * isn't in one, or is still approved so it can be switched off.
 */
const GroupCard = ({ groupCode, groupAssignment, groupsSaved, approved, onToggleApproved }) => {
    const group = groupAssignment
        ? (groupAssignment.name ? `${groupAssignment.number} · ${groupAssignment.name}` : `Group ${groupAssignment.number}`)
        : null;
    const staff = groupAssignment?.staff?.length ? groupAssignment.staff.join(', ') : null;
    const showApproval = groupsSaved && onToggleApproved && (!groupAssignment || approved);

    return (
        <Card
            id="group"
            title="Group Assignment"
            icon={Users}
            actions={showApproval
                ? <span className="tw-inline-flex tw-items-center tw-gap-2 tw-text-sm tw-text-neutral-600">
                    Approved
                    <Toggle checked={approved} onChange={onToggleApproved} label="Group assignment approved" />
                </span>
                : null}
        >
            <FieldGrid className="tw-grid tw-grid-cols-2 tw-gap-x-4 tw-gap-y-3 lg:tw-grid-cols-3">
                <Field icon={Users} label="Group" placeholder="Not assigned">{group}</Field>
                <Field icon={Hash} label="Code" placeholder="Not assigned">{groupCode}</Field>
                <Field icon={User} label="Staff" placeholder="Not assigned">{staff}</Field>
            </FieldGrid>
        </Card>
    );
};

export default GroupCard;
